module.exports = __webpack_public_path__ + "img/img-carrusel-empresas.5d04260.webp";